module.exports = __webpack_public_path__ + "img/delivery-success-with-wechat.0cb519d2.png";